import {
  getFinanceDashboardActionSummary,
  emptyFinanceDashboardSummary,
  type FinanceDashboardActionSummary,
} from './financeDashboard.service';
import {
  getSupplyChainDashboardActionSummary,
  emptySupplyChainDashboardSummary,
  type SupplyChainDashboardActionSummary,
} from './supplyChainDashboard.service';
import {
  getSalesDashboardActionSummary,
  emptySalesDashboardSummary,
  type SalesDashboardActionSummary,
} from './salesDashboard.service';

export type { FinanceDashboardActionSummary, SupplyChainDashboardActionSummary, SalesDashboardActionSummary };

export interface UnifiedDashboardActionSummary {
  finance: FinanceDashboardActionSummary;
  supply_chain: SupplyChainDashboardActionSummary;
  sales: SalesDashboardActionSummary;
}

export async function getUnifiedDashboardActionSummary(params?: {
  as_on_date?: string;
}): Promise<UnifiedDashboardActionSummary> {
  const [finance, supply_chain, sales] = await Promise.all([
    getFinanceDashboardActionSummary(params).catch(() => emptyFinanceDashboardSummary()),
    getSupplyChainDashboardActionSummary(params).catch(() => emptySupplyChainDashboardSummary()),
    getSalesDashboardActionSummary(params).catch(() => emptySalesDashboardSummary()),
  ]);
  return { finance, supply_chain, sales };
}
